import HomeData from './HomeData'

export default HomeData